(function () {
  window.OT = window.OT || {};

  function cleanPrice(text) {
    return String(text || '').replace(/\.00(?!\d)/g, '');
  }

  function setStickyBtnLabel(btn, label) {
    if (!btn) return;
    const text = label || btn.getAttribute('data-label') || 'Order now - Free Delivery 🚚';
    const textEl = btn.querySelector('.ot-sticky-order__btn-text');
    if (textEl) textEl.textContent = text;
    else btn.textContent = text;
  }

  OT.scrollToBuy = function () {
    const plan = document.getElementById('choose-plan');
    const buy = document.getElementById('buy-section');
    (plan || buy)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  OT.syncAtcLabel = function () {
    const btn = document.getElementById('atc-btn');
    if (!btn || btn.disabled || btn.dataset.otBusy === '1') return;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    btn.textContent = mobile
      ? btn.getAttribute('data-label-mobile') || 'Order now - Free Delivery 🚚'
      : btn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
  };

  OT.syncCoupleAtcLabel = function () {
    const btn = document.querySelector('.js-couple-atc');
    if (!btn || btn.disabled || btn.dataset.otBusy === '1') return;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    btn.textContent = mobile
      ? btn.getAttribute('data-label-mobile') || 'Order now - Free Delivery 🚚'
      : btn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
  };

  OT.syncStickyLabel = function () {
    const btn = document.getElementById('ot-sticky-order-btn');
    if (!btn || btn.disabled || btn.dataset.otBusy === '1') return;
    setStickyBtnLabel(btn);
  };

  OT.syncStickyFromPlanCard = function (card) {
    if (!card) return;
    const stickyPrice = document.getElementById('ot-sticky-price');
    const stickyCompare = document.getElementById('ot-sticky-compare');
    const stickyPlan = document.getElementById('ot-sticky-plan');
    const priceEl = card.querySelector('.plan-card__price');
    const compareEl = card.querySelector('.plan-card__compare');

    if (stickyPrice) {
      if (priceEl) stickyPrice.textContent = cleanPrice(priceEl.textContent.trim());
      else if (card.dataset.price) stickyPrice.textContent = 'Rs. ' + Number(card.dataset.price).toLocaleString('en-PK');
    }

    if (stickyCompare) {
      const compareText = compareEl?.textContent?.trim() || '';
      const compareNum = Number(card.dataset.compare) || 0;
      if (compareText) {
        stickyCompare.hidden = false;
        stickyCompare.textContent = cleanPrice(compareText);
      } else if (compareNum > 0) {
        stickyCompare.hidden = false;
        stickyCompare.textContent = 'Rs. ' + compareNum.toLocaleString('en-PK');
      } else {
        stickyCompare.hidden = true;
        stickyCompare.textContent = '';
      }
    }

    if (stickyPlan) {
      const pack = card.dataset.pack || card.querySelector('.plan-card__month, .plan-card__label')?.textContent?.trim() || '';
      const rangeEl = card.querySelector('.plan-card__perday--result');
      let range = '';
      if (rangeEl) {
        range = rangeEl.textContent.replace(/\s+/g, ' ').trim();
      } else if (card.dataset.kgMin && card.dataset.kgMax && card.dataset.planDays) {
        range = card.dataset.kgMin + '-' + card.dataset.kgMax + ' kg in ' + card.dataset.planDays + ' days';
      }
      stickyPlan.textContent = range ? pack + ' · ' + range : pack;
    }
  };

  function waitForCart(maxMs) {
    if (typeof OT.checkoutSelectedPack === 'function') return Promise.resolve();
    return new Promise(function (resolve) {
      const deadline = Date.now() + (maxMs || 3000);
      (function poll() {
        if (typeof OT.checkoutSelectedPack === 'function' || OT._cartReady) {
          resolve();
          return;
        }
        if (Date.now() >= deadline) {
          resolve();
          return;
        }
        setTimeout(poll, 40);
      })();
    });
  }

  OT.stickyOrderNow = async function () {
    const btn = document.getElementById('ot-sticky-order-btn');
    if (btn && btn.dataset.otBusy === '1') return;

    if (btn) {
      btn.disabled = true;
      btn.dataset.otBusy = '1';
      btn.textContent = 'Processing...';
    }

    let redirected = false;
    try {
      await waitForCart();

      if (typeof OT.checkoutSelectedPack === 'function') {
        redirected = await OT.checkoutSelectedPack();
        return;
      }

      const productForm = document.getElementById('ot-product-form');
      const coupleForm = document.getElementById('ot-couple-form');
      const id = productForm
        ? productForm.querySelector('[name="id"]')?.value
        : coupleForm
          ? coupleForm.querySelector('input[name="id"]:checked')?.value ||
            coupleForm.querySelector('input[name="id"]')?.value
          : null;

      if (id && typeof OT.buyNow === 'function') {
        const qty =
          document.getElementById('form-qty')?.value ||
          document.getElementById('qty-input')?.value ||
          1;
        redirected = await OT.buyNow(id, qty);
        return;
      }

      OT.scrollToBuy();
    } finally {
      if (!redirected && btn) {
        btn.disabled = false;
        btn.dataset.otBusy = '';
        OT.syncStickyLabel();
      }
    }
  };

  function clampScrollPosition() {
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    if (y > maxScroll + 1) window.scrollTo(0, maxScroll);
  }

  function resetPageLocks() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  OT.initStickyOrder = function () {
    const bar = document.getElementById('ot-sticky-order');
    if (!bar) return;
    if (bar.dataset.otStickyBound === '1') return;
    bar.dataset.otStickyBound = '1';

    const mobileMq = window.matchMedia('(max-width: 767px)');
    const stickyBtn = document.getElementById('ot-sticky-order-btn');

    if (stickyBtn && !stickyBtn.dataset.otBound) {
      stickyBtn.dataset.otBound = '1';
      stickyBtn.setAttribute(
        'data-label',
        stickyBtn.querySelector('.ot-sticky-order__btn-text')?.textContent.trim() || 'Order now - Free Delivery 🚚'
      );
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        OT.stickyOrderNow();
      });
    }

    function clearSticky() {
      bar.classList.remove('ot-sticky-order--visible');
      bar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ot-has-sticky-order');
    }

    function setStickyVisible(show) {
      if (!mobileMq.matches) {
        clearSticky();
        return;
      }
      bar.classList.toggle('ot-sticky-order--visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('ot-has-sticky-order', show);
    }

    function onDesktopViewport() {
      clearSticky();
      resetPageLocks();
      clampScrollPosition();
      OT.syncAtcLabel();
      OT.syncCoupleAtcLabel();
    }

    function updateStickyOrder() {
      if (!mobileMq.matches) {
        onDesktopViewport();
        return;
      }
      setStickyVisible(true);
      OT.syncAtcLabel();
      OT.syncCoupleAtcLabel();
    }

    function onViewportChange() {
      if (!mobileMq.matches) onDesktopViewport();
      else {
        clampScrollPosition();
        updateStickyOrder();
      }
    }

    window.addEventListener('resize', onViewportChange);
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', onViewportChange);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(onViewportChange);
    }
    onViewportChange();
    OT.syncStickyLabel();

    const stickyPrice = document.getElementById('ot-sticky-price');
    const stickyCompare = document.getElementById('ot-sticky-compare');
    if (stickyPrice) stickyPrice.textContent = cleanPrice(stickyPrice.textContent);
    if (stickyCompare && !stickyCompare.hidden) stickyCompare.textContent = cleanPrice(stickyCompare.textContent);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', OT.initStickyOrder);
  } else {
    OT.initStickyOrder();
  }
})();
